// Prefetch the next episode so a swipe lands on a ready video.
// Always: the play details (small JSON). Video segments only on Wi-Fi / fast networks and never with Data Saver,
// because many of our users pay per MB.
import { api } from './api';
import { prefetchQuery } from './query';

type NetInfo = { saveData?: boolean; effectiveType?: string; type?: string };

function canPrefetchVideo(): boolean {
  const c = (navigator as Navigator & { connection?: NetInfo }).connection;
  if (!c) return true;                       // unknown (e.g. iOS Safari): small, one segment only
  if (c.saveData) return false;
  if (c.type === 'cellular' && c.effectiveType !== '4g') return false;
  return c.effectiveType ? c.effectiveType === '4g' : true;
}

const warmed = new Set<string>();

/** Show details are small JSON: prefetch freely (on touch, and for posters on screen). */
export function prefetchShow(slug: string): void {
  prefetchQuery('show:' + slug, () => api.show(slug)).catch(() => {});
}

export function prefetchEpisode(showId: string, no: number, plus: boolean): void {
  const key = `play:${showId}:${no}:${plus}`;
  prefetchQuery(key, () => api.play(showId, no)).then((r) => {
    if (!r || !r.ok || !r.playlistUrl || warmed.has(r.playlistUrl) || !canPrefetchVideo()) return;
    warmed.add(r.playlistUrl);
    // Warm the HTTP cache: the playlist, then only its first segment.
    fetch(r.playlistUrl, { credentials: 'include' })
      .then((res) => (res.ok ? res.text() : ''))
      .then((text) => {
        const first = text.split('\n').map((l) => l.trim()).find((l) => l && !l.startsWith('#'));
        if (first) fetch(new URL(first, r.playlistUrl!).toString(), { credentials: 'include', priority: 'low' } as RequestInit).catch(() => {});
      })
      .catch(() => {});
  }).catch(() => {});
}
